import { render, staticRenderFns } from "./WizardWidget.vue?vue&type=template&id=8a5485b0&scoped=true"
import script from "./WizardWidget.vue?vue&type=script&lang=js"
export * from "./WizardWidget.vue?vue&type=script&lang=js"
import style0 from "./WizardWidget.vue?vue&type=style&index=0&id=8a5485b0&prod&lang=css"
import style1 from "./WizardWidget.vue?vue&type=style&index=1&id=8a5485b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5485b0",
  null
  
)

export default component.exports